import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {data} from "autoprefixer";
import {LabManagerService} from "../../../lab-manager/lab-manager.service";
import {LabSampleModel} from "../../../models/lab-manager/lab-sample";
import {NavBarComponent} from "../../../nav-bar/nav-bar.component";
import dayjs from "dayjs";
import {BasicLabManagerItemModel} from "../../../models/lab-manager/basic-lab-manager-item";
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from "@angular/material/core";
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from "@angular/material-moment-adapter";

export const MY_FORMATS = {
  parse: {
    dateInput: "YYYY-MM-DD"
  },
  display: {
    dateInput: "YYYY-MM-DD",
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: "YYYY-MM-DD",
    monthYearA11yLabel: "YYYY-MM-DD"
  }
};

@Component({
    selector: 'app-add-samples-dialog',
    templateUrl: './add-samples-dialog.component.html',
    styleUrls: ['./add-samples-dialog.component.css'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ],
    standalone: false
})
export class AddSamplesDialogComponent implements OnInit {

  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  filterStartDate: string = '';
  filterEndDate: string = '';
  sampleGroups: any[] = []
  currentPage: number = 0;
  totalElements: number = 0;
  pageSize: number = 9999;
  searchText: string = '';
  startDate: string = '';
  endDate: string = '';
  selectedSampleGroups: any[] = [];
  tenantId: number = 0;
  pinTypeId: number = 0;
  timerInterval: any = null;
  selectedSamples: any = [];
  isFilterBtnVisible: boolean = false;

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<AddSamplesDialogComponent>,
      private labManagerService: LabManagerService,
      private nav: NavBarComponent
  ) {
  }

  ngOnInit(): void {
    // let callResponse = this.data.callResponse;
    // this.dataSource = new MatTableDataSource<any>(callResponse.content);
    this.tenantId = this.data.tenantId;
    this.pinTypeId = this.data.pinTypeId;
    this.getLabSampleList();
    this.labManagerService.getSampleGroupList(this.tenantId).subscribe({
      next: (res) => {
        this.sampleGroups = res;
      }
    })
  }

  resetFilter(){
    this.searchText = '';
    this.startDate = '';
    this.endDate = '';
    this.filterStartDate = '';
    this.filterEndDate = '';
    this.selectedSampleGroups = [];
    this.isFilterBtnVisible = false;
    this.getLabSampleList();
  }

  getLabSampleList() {
    if(this.timerInterval) {
      clearInterval(this.timerInterval);
    }

    this.nav.toggleLoading(true);
    this.labManagerService.getLabSamplesList(this.tenantId, this.pinTypeId, this.currentPage, this.pageSize, this.startDate, this.endDate, this.searchText, this.selectedSampleGroups).subscribe({
      next: (res: any) => {
        this.nav.toggleLoading(false);
        this.dataSource = res;

      },
      error: () => {
        this.nav.toggleLoading(false);
      }
    })
  }

  searchLabSamples() {
    if(this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    this.timerInterval = setInterval(() => {
      this.isFilterBtnVisible = true;
      this.getLabSampleList();
    }, 800);
  }

  filterDateRange() {
    if(this.filterStartDate && this.filterEndDate) {
      this.isFilterBtnVisible = true;
      this.startDate = this.filterStartDate ? dayjs(this.filterStartDate).format('YYYY-MM-DD') : '';
      this.endDate = this.filterEndDate ? dayjs(this.filterEndDate).format('YYYY-MM-DD') : '';
      this.getLabSampleList();
    }
  }

  closeDialog(selectedSamples?: any[]) {
    this.dialogRef.close(selectedSamples);
  }

}
